import { createRestAPI } from '@dabble/rest-client';
import { getActiveUid } from './getActiveUid';
import { REST_URL } from '../data/env';

const rest = createRestAPI(REST_URL);

// Guard against an empty `x-uid`. Many call sites pass `userStore.user?.uid || ''`,
// which sends `x-uid: ''` if the user isn't loaded yet. The backend treats an
// empty hint as "no hint" and resolves to the admin/most-recent account
// (resolveCookieAuth) — the wrong account for an admin or multi-account user,
// and since DAB-559 the cookie is never reordered so it can't self-correct.
// When that happens, backfill from the active uid; if there's none, drop the
// header so identity falls back to the cookie cleanly.
rest.hook((req) => {
  if (req.header('x-uid') === '') {
    const activeUid = getActiveUid();
    if (activeUid) req.header('x-uid', activeUid);
    else (req.init.headers as Headers).delete('x-uid');
  }
});

export default rest;
